export const defaultPages = ['searching', 'signup', 'checkout', 'upsell', 'success'];

const lp1Default = ['one_pager', ...defaultPages];

const legalFlow = [
  'one_pager_prnt_lg',
  'signup_prnt_lg',
  'paycheck_prnt_lg',
  'success',
]
export const flowsList: Record<string, string[]> = {
  default: [...legalFlow],
  lp1ch2: lp1Default,
  lp1ch3: lp1Default,
  lp1ch2up1: lp1Default,
  lp1ch4: lp1Default,
  lp1ch5: lp1Default,
  lp1ch6: lp1Default,
  lp1ch7: lp1Default,
  lp11ch8: lp1Default,
  lp11ch9: lp1Default,
  lp11ch10: lp1Default,
  lp11ch11: lp1Default,
  lp11ch12: lp1Default,
  lp12ch8: lp1Default,
  lp2ch2: lp1Default,
  lp3ch2: lp1Default,
  lp14ch8: ['one_pager', 'searching', 'signup', 'features', 'checkout', 'upsell', 'success'],
  lp17ch17p5: [
    'one_pager_all',
    'searching_2',
    'signup_testim',
    'checkout_v3_tr',
    'upsell_ar_flight',
    'success',
  ],
  lp17fastpay: [
    'one_pager_all',
    'searching_2',
    'signup_testim',
    'paycheck1_pr5d_fastpay',
    'upsell_ar_flight',
    'success',
  ],
  hdl_kw: [
    'one_pager_all5_kwtt',
    'searching_2',
    'signup_testim',
    'features',
    'paycheck4_pr3d_h_fastpay2_ntp',
    'upsell_ar_flight_tp',
    'upsell_guide_tp',
    'success',
  ],
  blk: [
    'one_pager_all5',
    'searching_2',
    'signup_testim',
    'features',
    'paycheck4_pr3d_h_pln',
    'success',
  ],
  flpm_rt: [
    'one_pager_all5',
    'searching_3_an',
    'signup_testim',
    'features',
    'paycheck4_pr3d_h_fastpay2_ntp',
    'upsell_ar_flight_tp',
    'upsell_guide_tp',
    'success',
  ],
  one_pager_all2: [
    'one_pager_all2',
    'searching_2',
    'signup_testim',
    'checkout_v3_tr',
    'upsell_ar_flight',
    'success',
  ],
  one_pager_all3: [
    'one_pager_all3',
    'searching_2',
    'signup_testim',
    'checkout_v3_tr',
    'upsell_ar_flight',
    'success',
  ],
  one_pager_all5_blck: [
    'one_pager_all5',
    'searching_2',
    'signup_testim',
    'features',
    'paycheck4_pr3d_h_fastpay2_ntp',
    'upsell_ar_flight_tp',
    'upsell_guide_tp',
    'success',
  ],
  plv_lng_tst: [
    'one_pager_all5_gnhdl',
    'searching_2',
    'signup_testim',
    'features',
    'paycheck4_pr3d_h_fastpay2_ntp',
    'upsell_ar_flight_tp',
    'upsell_guide_tp',
    'success',
  ],
  ln_nw: [
    'one_pager_all5_gnhdl',
    'searching_2',
    'signup_testim',
    'features',
    'paycheck4_pr3d_h_fastpay2_ntp',
    'upsell_ar_flight_tp',
    'upsell_guide_tp',
    'success',
  ],
};
